import { StaffCommentSubjectInput } from '../../lib/types/models/staff-comment-subject/staff-comment-subject-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateStaffCommentSubject(data: UpdateInput<StaffCommentSubjectInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.staffCommentSubjects.update.url, { id }))
    .patch(rest)
}
